<template>
  <div>
    <TopBar />
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-1">
        </div>
        <div class="col-sm-3" style="padding:20px;">
          <MenuSetup />
        </div>
        <div class="col-sm-7">
          <router-view/>
          <div class="steps">
            <div class="step">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-sm-10">
                    {{ $t('system') }}
                  </div>
                  <div class="col-sm-2">
                    <img v-if="system" class="stepi" src="../assets/setup-ok.png" />
                    <img v-if="!system" class="stepi" src="../assets/setup-ko.png" />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="system" class="step">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-sm-10">
                    {{ $t('browser') }}
                  </div>
                  <div class="col-sm-2">
                    <img v-if="nav" class="stepi" src="../assets/setup-ok.png" />
                    <img v-if="!nav" class="stepi" src="../assets/setup-ko.png" />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="nav" class="step">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-sm-10">
                    {{ $t('application') }}
                  </div>
                  <div class="col-sm-2">
                    <img v-if="appli=='ok'" class="stepi" src="../assets/setup-ok.png" />
                    <img v-if="appli=='search'" class="stepi" src="static/img/setup-ld.gif" />
                    <img v-if="!appli" class="stepi" src="../assets/setup-ko.png" />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="system && nav && !appli" class="step">
              <div v-if="step==1" class="alert alert-info" style="color:black; text-align: center;">
                  <h3>{{ $t('step') }} 1</h3>
                  <div style="margin: 30px;">
                    <span style="color:black; font-size: 16px;">
                      {{ $t('plugProg') }}
                    </span>
                  </div>
                  <div class="lesbtns">
                    <a class="btn btn-light" v-on:click="step=2">{{ $t('next') }}</a>
                  </div>
              </div>
              <div v-if="step==2" class="alert alert-info" style="color:black; text-align: center;">
                  <h3>{{ $t('step') }} 2</h3>
                  <div style="margin: 30px;">
                    <a class="linkDwn" v-bind:href="linkSetup" target="_blank">
                      <img style="height:20px;" src="../assets/direct-download.svg" /> {{ $t('downloadSoft') }}
                    </a>
                  </div>
                  <div class="lesbtns">
                    <a class="btn btn-light" v-on:click="step=3">{{ $t('next') }}</a>
                  </div>
              </div>
              <div v-if="step==3" class="alert alert-info" style="color:black; text-align: center;">
                  <h3>{{ $t('step') }} 3</h3>
                  <div style="margin: 30px;">
                    <span style="color:black; font-size: 16px;">
                      <p v-html="$t('clickOnSoft')"></p>
                    </span>
                  </div>
                  <div class="lesbtns">
                      <a class="btn btn-light" v-on:click="runSetup">{{ $t('reloadTest') }}</a>
                  </div>
              </div>
            </div>
            <div v-if="appli=='ok'" class="step">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-sm-10">
                    {{ $t('programmer') }}
                  </div>
                  <div class="col-sm-2">
                    <img v-if="prog=='ok'" class="stepi" src="../assets/setup-ok.png" />
                    <img v-if="prog=='search'" class="stepi" src="static/img/setup-ld.gif" />
                    <img v-if="!prog" class="stepi" src="../assets/setup-ko.png" />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="prog=='ok'" id="actions" style="text-align: center; width: 80%; margin: 20px auto;">
              <div class="alert alert-info">
                <div style="font-size:24px; font-weight: bold; margin-bottom: 10px; color:#08c;">
                  {{ $t('whatDoYouWhat') }}
                </div>
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-sm-6">
                      <a class="act" v-on:click="runReadBadge">
                        <span>{{ $t('readAnTag') }}</span>
                        <img class="bimg" src="../assets/badge/29.png">
                      </a>
                    </div>
                    <div class="col-sm-6">
                      <a class="act" v-on:click="runReadStick">
                        <span>{{ $t('readAnEtikronic') }}</span>
                        <img class="bimg" src="../assets/badge/31.png">
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-1">
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import TopBar from './TopBar.vue'
import MenuSetup from './MenuSetup.vue'

export default {
  name: 'SetupUsb',
  components: {
      TopBar,
      MenuSetup
  },
  data: function() {
    return {
      system : false,
      nav : false,
      appli : '',
      prog : false,
      step : 1,
      linkSetup : ''
    }
  },
  created: function () {
    let self = this;
    document.title = this.$i18n.t(`titleProg`);
    this.$root.$on('runSetup', function () {
      self.runSetup();
      //alert("runSetup : "+JSON.stringify(d));
    })
    this.runSetup();
  },
  beforeDestroy(){
    this.$root.$off('runSetup');
    Prog.close();
  },
  methods : {
    getOS() {
      var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;
      this.linkSetup = '/app/win/WSProgrammerFull235.exe';

      if (macosPlatforms.indexOf(platform) !== -1) {
        this.linkSetup = 'https://apps.apple.com/fr/app/programmateur/id1472162168?mt=12';
        os = 'MacOS';
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
      } else if (/Android/.test(userAgent)) {
        os = 'Android';
      } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
      }
      return os;
    },
    runSetup(){
      this.getOS();
      let self = this;
      this.step = 1;
      this.system = false;
      this.nav = false;
      this.appli = '';
      this.prog = false;
      Prog.close();
      setTimeout(function(){
        self.runSetupFull();
      },300);
    },
    runReadBadge(){
      this.$router.push('/badge');
    },
    runReadStick(){
      this.$router.push('/etiktronic');
    },
    runSetupFull(){
      //alert("methods runSetup");
      try {
        let self = this;
        var compa = Prog.test.system();
        if (!compa) {
          this.system = false;
        } else {
          this.system = true;
          if (Prog.test.nav()) {
            this.nav = true;
          } else {
            this.nav = false;
            return;
          }
          Prog.install();
          self.appli = 'search';
          self.prog='search';
          Prog.init(function (d) {
            if (d.error && d.error == 404) {
              var cook = Prog.getCookie('pp', '');
              var mess = (cook != '') ? "app-plug" : "app-dwn";
              self.appli='';
              Prog.close();
              return;
            }
            self.appli = 'ok';
            if (d.connect == 1) {
              self.prog = 'ok';
            } else {
              self.prog = false;
              Prog.close();
              return;
            }
        Prog.close();
      }, function (e) {
        if (!e) {
          self.appli='ok';
        }else{
          self.appli=false;
          if (e.error && e.error == 'too many client') {
            if (e.host && e.host != '') {
              $('#urlSite').html(e.host);
            }
          }
        }
      });
    }
  } catch (e) {
    Prog.log('Error : ' + e.message);
  }
}
}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.steps {
  text-align: left;
  margin:30px;
  font-size: 20px;
  font-weight: bold;
  color: #666;
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
}
.bimg {
  height: 50px;
}
a:hover h3 {
  color: #043967;
}
.step {
  margin:10px 20px;
}
.stepi {
  height: 24px;
}
a.act {
  margin: 10px auto;
  width: auto;
  padding: 10px;
  display: block;
  color : grey;
  background: #f8f8f8;
  border-radius: 10px;
  text-align: center;
  text-decoration: none;
}
a.act:hover {
  background: #eee;
  color : #08c;
  text-decoration: none;
}
a.act span {
  display: block;
}
a.act img {
  height: 50px;
}
.alert-info {
  /*margin:20px;*/
  margin-top:30px;
  color: #3a87ad;
  background-color: #d9edf7;
  border-color: #bce8f1;
}
.lesbtns {
  text-align: center;
  padding: 10px;
}
a.linkDwn {
    margin: 20px;
    width: auto;
    font-size: 16px;
    padding: 15px 30px;
    margin-bottom: 20px;
    /*display: block;*/
    background: #f2f2f2;
    border-radius: 10px;
    text-align: left;
    color:#222!important;
    text-decoration: none;
}
a.linkDwn:hover {
    /*background: #aaa;*/
    background: #0f66aa;
    color:#fff!important;
    text-decoration: none;
}
a.linkDwn span {
    display: block;
}
</style>
